import script from "./Justificacion2025Listado.vue?vue&type=script&setup=true&lang=ts"
export * from "./Justificacion2025Listado.vue?vue&type=script&setup=true&lang=ts"

import "./Justificacion2025Listado.vue?vue&type=style&index=0&id=39537ac2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39537ac2"]])

export default __exports__